define('cartware_checkout/components/login',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	BEM,
	PopupHtml
) {
	var _popupTemplate = null;

	return Component.create({
		block:		null,
		hintLink:	null,
		loginBlock:	null,

		$init: function() {
			var self = this;

			this.block = BEM.block("cartware-checkout");
			this.hintLink = this.block.getElements("login-hint");
			this.loginBlock = BEM.block("cartware-checkout-login");

			this.hintLink.on("click", function(e) {
				e.preventDefault();

				$.magnificPopup.open({
					items: {
						src: self._renderPopup({
							title: self.loginBlock.getElements('title').html(),
							body: self.loginBlock.getElements('content').html()
						}),
						type: 'inline'
					}
				});
			});
		},

		_renderPopup: function(data) {
			if (null === _popupTemplate) {
				_popupTemplate = _.template(PopupHtml);
			}

			return _popupTemplate(data);
		}
	});
});
